import i18n from "i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

i18n
    // load translation using http -> see /public/locales
    .use(Backend)
    // detect user language
    .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    .init({
        fallbackLng: "es",
        supportedLngs: ["es", "en"],
        nonExplicitSupportedLngs: true,
        load: "languageOnly",
        debug: false,
        interpolation: {
            escapeValue: false // not needed for react as it escapes by default
        },
        backend: {
            loadPath: '/locales/{{lng}}/{{ns}}.json'
        }
    })
    .then((t) => {
        console.log("i18n initialized successfully");
        const updateDocumentLanguage = (language: string) => {
            document.documentElement.lang = language.split("-")[0];
            document.title = i18n.t("app.title");
        };

        updateDocumentLanguage(i18n.resolvedLanguage || i18n.language);
        i18n.on("languageChanged", updateDocumentLanguage);
    })
    .catch((err) => {
        console.error("i18n initialization failed:", err);
    });

export default i18n;
